export const STATE_NAME = "busyIndicator";
